var React = require('react');

function IconDownloadInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#DA291C","d":"M11.516 7.003L6.969 11.64c-.145.147-.378.147-.523 0L1.9 7.003c-.144-.147-.144-.385 0-.532l.602-.612c.148-.15.384-.147.526.006L5.906 8.9V1.125c0-.206.165-.375.368-.375h.86c.203 0 .37.169.37.375v7.774l2.878-3.034c.145-.15.381-.153.526-.006l.602.612c.15.147.15.385.006.532zm.722 5.747H1.176c-.203 0-.368.104-.368.23v.54c0 .126.165.23.368.23h11.062c.203 0 .369-.104.369-.23v-.54c0-.126-.166-.23-.369-.23z"}));
}

IconDownloadInline.defaultProps = {"width":"13","height":"14","viewBox":"0 0 13 14"};

module.exports = IconDownloadInline;

IconDownloadInline.default = IconDownloadInline;
